import LocalizationKeys from '../i18n/LocalizationKeys'
import i18n from '../i18n/setupLocalization'
import { SBModelUlid } from './SBmodel'
import dayjs from 'dayjs'
import isBetween from 'dayjs/plugin/isBetween'

export interface Automation extends SBModelUlid {
  name: string
  isActive: boolean
  shouldReact: boolean
  delayBetweenMessages: number
  followerReplyDelay: number
  notFollowerReplyDelay: number
  followerTimeLimiter: number
  notFollowerTimeLimiter: number
  scheduledFrom?: string
  scheduledTo?: string

  // Relations
  followerAnswers: string[]
  notFollowerAnswers: string[]
}
dayjs.extend(isBetween)

export type AutomationStatus = 'live' | 'scheduled' | 'paused'

export const getAutomationStatus = (
  automation: Automation
): AutomationStatus => {
  if (automation?.isActive && !automation?.scheduledFrom) {
    return 'live'
  } else if (automation?.scheduledFrom) {
    return dayjs().isBetween(
      dayjs(automation.scheduledFrom),
      dayjs(automation.scheduledTo),
      'minute',
      '[]'
    )
      ? 'live'
      : 'scheduled'
  }
  return 'paused'
}
export const getAutomationStatusLabel = (automation: Automation): string => {
  const status = getAutomationStatus(automation)
  var key = LocalizationKeys.Page.AutomationPage.StatusLive
  if (status === 'scheduled') {
    key = LocalizationKeys.Page.AutomationPage.StatusScheduled
  } else if (status === 'paused') {
    key = LocalizationKeys.Page.AutomationPage.StatusPaused
  }
  return i18n.t(key)
}
